(function($) {

    $(window).on('load resize orientationChange', function(event) { 
        init_bubbles_slider();
    });

    
    function init_bubbles_slider() {
            
        $('.bubbles__wrapper').each(function(index){

            if(!$(this).hasClass('slick-initialized') && $(window).width() < 992) {

                $(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    infinite: true,
                    autoplay: false,
                    swipe: true,
                    centerMode: true,
                    variableWidth: true,
                    mobileFirst: true,

                    responsive: [
                        {
                          breakpoint: 992,
                          settings: "unslick"
                        }
                    ]
                });
            }
        });
    }


})(jQuery);